/**
 * @version: v 1.0.0
 * @Author: zengying
 * @Date: 2022/9/28 10:23
 * @FileName: about.js
 * @LastEditor: 2022/9/28 10:23
 * @Name: news
 */


const about = {
  routes: [
    {
      path: '/news',
      name: 'news',
      meta: {
        title: '树'
      },
      component: () => import('@/project/views/news/news.vue')
    },
    {
      path: '/companyNews',
      name: 'companyNews',
      meta: {
        title: '树'
      },
      component: () => import('@/project/views/news/company-news/company-news.vue')
    },
    {
      path: '/marketInsight',
      name: 'marketInsight',
      meta: {
        title: '树'
      },
      component: () => import('@/project/views/news/market-insight/market-insight.vue')
    }
  ]
};
export default about;




// WEBPACK FOOTER //
// ./src/project/router/news.js